import { todayUpdates } from '@/mocks/movies';
import SectionHeading from './SectionHeading';

const typeStyles: Record<string, string> = {
  网络上线: 'bg-secondary-100 text-secondary-900',
  加映场次: 'bg-accent-100 text-accent-900',
  新片上映: 'bg-primary-100 text-primary-800',
  分集更新: 'bg-background-200 text-foreground-800',
  口碑更新: 'bg-accent-100 text-accent-900',
  预告放出: 'bg-background-200 text-foreground-800',
  高分推荐: 'bg-secondary-100 text-secondary-900',
};

export default function TodayUpdates() {
  return (
    <section id="today" className="w-full bg-background-100 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="今日更新"
          title="今天都更新了什么，按时间一次看完"
          desc="当天的上线、加映、分集更新与预告通常集中在这里。时间越靠后往往越完整，建议每天固定回来看一眼，避免错过追更节点。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-[1.6fr_1fr]">
          <ol className="relative border-l border-background-300 pl-6">
            {todayUpdates.map((item) => (
              <li key={item.id} className="relative pb-7 last:pb-0">
                <span className="absolute -left-[31px] flex h-4 w-4 items-center justify-center rounded-full border-2 border-background-100 bg-primary-500"></span>
                <div className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-heading text-base font-bold text-foreground-950">{item.time}</span>
                    <span className="text-sm font-medium text-foreground-800">{item.title}</span>
                    <span
                      className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${
                        typeStyles[item.type] ?? 'bg-background-200 text-foreground-800'
                      }`}
                    >
                      {item.type}
                    </span>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.detail}</p>
                </div>
              </li>
            ))}
          </ol>

          <aside className="h-fit rounded-lg border border-background-200 bg-background-50 p-5">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className="ri-lightbulb-line text-base" aria-hidden="true"></i>
              </span>
              追更小提示
            </h3>
            <ul className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-700">
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-secondary-600" aria-hidden="true"></i>
                想第一时间知道新片，优先看带「新片上映」标记的条目。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-secondary-600" aria-hidden="true"></i>
                追剧集类内容时，留意「分集更新」后面的集数说明。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-secondary-600" aria-hidden="true"></i>
                想进影院前，先核对「院线同步」里的状态，再决定场次。
              </li>
            </ul>
            <div className="mt-5 rounded-md bg-background-100 p-3 text-xs leading-relaxed text-foreground-600">
              以上为页面整理的当日更新节奏示例，具体时间与内容以实际为准。
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}